<template>
  <div>
    <v-btn v-if="mode === 'modal'" ref="menuButton" outlined class="menu-button" @click="dialog = true">View the Keepsake Menu</v-btn>
    <v-dialog v-if="mode === 'modal'" v-model="dialog" max-width="760" @keydown.esc="closeDialog">
      <div role="dialog" aria-modal="true" :aria-labelledby="menuTitleId"><button class="close-button" aria-label="Close menu" @click="closeDialog">Close</button><MenuPaper :menu="menu" :title-id="menuTitleId" /></div>
    </v-dialog>
    <div v-else class="menu-keepsake" :class="{ 'has-image': menu.image }"><figure v-if="menu.image"><v-img :src="menu.image | mediaSrc" :alt="menu.imageAlt || ''" aspect-ratio=".75" /><figcaption v-if="menu.imageCaption">{{ menu.imageCaption }}</figcaption></figure><MenuPaper :menu="menu" :title-id="menuTitleId" /></div>
  </div>
</template>
<script>
import MenuPaper from './MenuPaper.vue';

export default {
  name: 'KeepsakeMenuCard',
  components: { MenuPaper },
  props: { menu: { type: Object, required: true }, mode: { type: String, default: 'inline', validator: (value) => ['inline', 'modal'].includes(value) } },
  data: () => ({ dialog: false }),
  computed: { menuTitleId() { return `keepsake-menu-${this.menu.year}`; } },
  watch: { dialog(value) { if (!value) this.$nextTick(() => this.$refs.menuButton?.$el?.focus()); } },
  methods: { closeDialog() { this.dialog = false; } },
};
</script>
<style scoped>.menu-button{border-color:#c8a45e!important;color:#fff!important}.close-button{background:#1d1b16;border:1px solid #c8a45e;color:#fff;float:right;margin:12px;padding:8px 12px}.menu-keepsake.has-image{align-items:start;display:grid;gap:14px;grid-template-columns:minmax(170px,.75fr) minmax(280px,1.25fr)}figure{background:#131210;border:1px solid #352f25;margin:0;overflow:hidden}figcaption{color:#aaa;font-size:.75rem;line-height:1.45;padding:12px 14px}@media(max-width:700px){.menu-keepsake.has-image{grid-template-columns:1fr}}</style>
